import ProductSlider from './product-slider';

const loadProductRecommendationsIntoSection = () => {
  // Look for an element with class 'product-recommendations'
  const productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  const productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  const limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  const requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax

  const request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = () => {
    if (request.status >= 200 && request.status < 300) {
        const container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

        const slider = document.querySelector('[data-product-slider]');
        new ProductSlider(slider);
    }
  };
  request.send()

};

loadProductRecommendationsIntoSection();